import { PageTemplate } from '@spa/lib/cms/const';
import { RootState } from '@spa/lib/store/RootState';

const selectPageTemplate = (state: RootState): PageTemplate => {
  return state.router.pageTemplate;
};

export default selectPageTemplate;
